/**
 * Copyright (c) 2026 Accunai India Services Pvt. Ltd. All rights reserved.
 *
 * PROPRIETARY AND CONFIDENTIAL
 *
 * This file is part of proprietary software owned by Accunai India Services Pvt. Ltd.
 * Unauthorized copying, distribution, modification, or use of this file,
 * in whole or in part, via any medium, is strictly prohibited without
 * prior written permission from Accunai India Services Pvt. Ltd.
 *
 * Generated with GitHub Copilot Business/Enterprise.
 * Reviewed and approved by: AI-assisted / 2026-07-13
 */

export const constants = {
  API_BASE_URL: process.env.REACT_APP_BASE_URL || "https://fallback-url.com",
  REACT_APP_ADD_ADMIN_BUTTON: String(process.env.REACT_APP_ADD_ADMIN_BUTTON).trim().toLowerCase() === "true",
  REACT_APP_ADD_BULK_EXPERT_BUTTON: String(process.env.REACT_APP_ADD_BULK_EXPERT_BUTTON).trim().toLowerCase() === "true",
  REACT_APP_ADD_VENDOR: String(process.env.REACT_APP_ADD_VENDOR).trim().toLowerCase() === "true",
  REACT_APP_BULK_ONBOARD_BUTTON: String(process.env.REACT_APP_BULK_ONBOARD_BUTTON).trim().toLowerCase() === "true",
  REACT_APP_BULK_DEBOARD_BUTTON: String(process.env.REACT_APP_BULK_DEBOARD_BUTTON).trim().toLowerCase() === "true",
  CREATE_PROJECT_FEATURE: String(process.env.REACT_APP_CREATE_PROJECT_FEATURE).trim().toLowerCase() === "true",
  REACT_APP_ENABLE_REVIEW_STAGES: String(process.env.REACT_APP_REVIEW_STAGES).trim().toLowerCase() === "true",
  REACT_APP_ACTIONS_ENABLED: String(process.env.REACT_APP_ACTIONS_ENABLED).trim().toLowerCase() === "true",
  REACT_APP_GIGSOURCE_ADD_STAGE_LINK:
    process.env.REACT_APP_GIGSOURCE_ADD_STAGE_LINK || "",
};
